<div class="holder">
  <h1>QR Okuyucu</h1>
  <button (click)="modalVisible = true" class="btn btn-primary">
    QR Okuyucuyu Aç
  </button>

  <div *ngIf="loading" class="loader-wrapper">
    <span class="loader"></span>
  </div>

  <div class="mobile-table-holder" *ngIf="verifyResultList.length > 0">
    <div class="mobile-table-item-list" *ngFor="let item of verifyResultList">
      <div class="mobile-table-item">
        <div class="mti-title">İndirim Kullanıma Uygun Mu?</div>
        <div class="mti-value">
          <span *ngIf="canUseDiscount(item)" style="color: green"> UYGUN </span>
          <span *ngIf="!canUseDiscount(item)" style="color: red">
            UYGUN DEĞİL
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-wrapper" [ngClass]="{ hide: !modalVisible }">
  <div class="modal-container">
    <div class="modal-header">
      <h3>QR Okuyucu Kamera</h3>
      <div class="modal-close" (click)="modalVisible = false"></div>
    </div>

    <div class="modal-body">
      <zxing-scanner
        [enable]="modalVisible"
        (scanSuccess)="onScanSuccess($event)"
        [formats]="allowedFormats"
      ></zxing-scanner>
    </div>
  </div>
</div>
